import { useContext, useEffect, useState } from 'react';
import { ApprovalContext } from './Approvals';
import css3 from '../css/batch-approval-table.module.css';
import {FiMoreHorizontal as MoreIcon} from 'react-icons/fi';
import Checkbox from '@mui/material/Checkbox';
import { useDispatch } from 'react-redux';
import { setAllBatchApproval } from '../../../../reduxSlice/batchApprovalSlice';
import {AiOutlineSearch as SearchIcon} from 'react-icons/ai';
import {IoReload as ReloadIcon} from 'react-icons/io5';
import { FilterDropDown, Loading } from '../../../../ui-components';
import styled from '@emotion/styled';


const EMPTY_ROWS: any[] = [];

const ApprovalTable = (props:any) =>{
    const [isCheck, setIsCheck] = useState<string[]>([]);
    const [list, setList] = useState([]);
    const [isCheckAll, setIsCheckAll] = useState(false);
    // Rows arrive already paginated by the server (see DisplayApproval).
    const data:any = props?.data ?? EMPTY_ROWS;
    const pageData = data;

    const setSearchData = props?.setSearchData
    const searchData = props?.searchData

    const setSearchData1 = (input: any) => {
        setSearchData(input)
        setList([]);
        setIsCheck([]);
        setIsCheckAll(false);
    }

    const dispatch = useDispatch()

    const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
        setIsCheckAll(!isCheckAll);
        setIsCheck(list?.map((item: any) => item?.AppMemberId))
        if(isCheckAll){
            setIsCheck([]);
        }
    }

    const handleClick = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {id, checked} = e.target;
        setIsCheck([...isCheck, id]);
        if(!checked ){
            setIsCheck(isCheck.filter(item => item !== id));
        }
    }

    const filterBatchApprovalData = list?.filter((data1: any) =>{
        return isCheck.some((data2: any) => {
            return data1?.AppMemberId === data2;
        })
    });
    
    

    useEffect(() => {
        dispatch(setAllBatchApproval(filterBatchApprovalData));
        if(list?.length < 1) return
        list?.length !== isCheck?.length ? setIsCheckAll(false) : setIsCheckAll(true);
    }, [isCheck])



    // Keep the selectable list in sync with the rows shown; a new page or
    // search result clears the selection so hidden rows are never submitted.
    useEffect(() => {
        setList(data);
        setIsCheck([]);
        setIsCheckAll(false);
    }, [data]);

    // useEffect(() => {
    //         if(checkAllStatus) dispatch(setAllBatchApproval(data));
    // }, [data, checkAllStatus])

    return (
        <>
            <Section1>
                <div className='searchWrapper'>
                    <label className={'searchForm'}>
                        <span className={'sI'}><SearchIcon/></span>
                        <input value = {searchData} onChange={(e) => setSearchData1(e.target.value)} type="text" placeholder='Search' />
                        <button className={'rBtn'} type="submit"><ReloadIcon/></button>
                    </label>
                    <FilterDropDown  text="Role" bg="#E2E4E9" color="#020D08" options={7} />
                    <FilterDropDown  text="Data Range" bg="#E2E4E9" color= '#020D08' options={3} />
                </div>
                <span>Select All  <Checkbox id='selectAll' onChange={handleSelectAll} checked={isCheckAll} sx={{marginBlockEnd: '3px'}}/></span>
            </Section1>
            {
            data?.length > 0 ? 
            <div className={css3.container}>
                <>
                    <div style={{gridTemplateColumns:` 0.3fr repeat(6,.8fr)`, backgroundColor: '#E0FAEE'}}>
                        <div></div>
                        <div>Applicant Id</div>
                        <div>First Name</div>
                        <div>Surname Name</div>
                        <div>Email Address</div>
                        <div> Score</div>
                        <div>Approval Status</div>
                    </div>
                    <div>
                        {pageData && pageData.length > 0 && pageData?.map((eData:any,index:number):any =>
                            <div key={index} style={{gridTemplateColumns:`0.3fr repeat(6,.8fr)`}}>
                                    <div><Checkbox onChange={handleClick} id={eData?.AppMemberId} checked={isCheck.includes(eData?.AppMemberId)}/></div>
                                    <div>{eData?.AppMemberId}</div>
                                    <div>{eData.FirstName}</div>
                                    <div>{eData.LastName}</div>
                                    <div>{eData.Email || 'N/A'}</div>
                                    <div>{eData.Score || 'N/A'}</div>
                                    <div>{eData?.TotalScore === 0 ? 'pending' : 'Approved'}</div>
                            </div>
                        )}
                    </div>
                </>
            </div>  :
            <NoResult>No Results</NoResult>
            }
            
        </>
    )
}

export default ApprovalTable;

const Section1 = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 46px;
    & span{
        font-size: 16px;
    }

    & .searchWrapper{
        margin-block-start: 1.6px;
        display: flex;
        gap: 10px;
    }

    & .searchForm{
        width: 250px;
        position: relative;
        display: flex;
        align-items: center;
    }

    &   .sI{
        position: absolute;
        left:7px;
    }

    &  .rBtn{
        position: absolute;
        right:7px;
        border:none;
        outline:none;
        background-color: transparent;
        cursor: pointer;
    }
    &   .searchForm > input{
        width:100%;
        outline:none;
        border: 1px solid #E2E4E9;
        padding:15px 30px 15px 30px;
        border-radius: 5px;
}
`


const NoResult = styled.div`
  margin-block-end: 25px;
`